import { Stats } from "fs";

export interface IInputFileSystem {
    stat(path: string, callback?: (err: NodeJS.ErrnoException, stats: Stats) => void): void;
    readdir(path: string, callback: (err: Error, files: string[]) => void): void;

    readFile(
        filename: string,
        options:
            | string
            | {
                  encoding: string;
                  flag?: string;
              },
        callback: (err: NodeJS.ErrnoException, data: string) => void
    ): void;
    readFile(
        filename: string,
        options: {
            flag?: string;
        },
        callback: (err: NodeJS.ErrnoException, data: Buffer) => void
    ): void;

    readFile(filename: string, callback: (err: NodeJS.ErrnoException, data: Buffer) => void): void;
    readlink(path: string, callback?: (err: NodeJS.ErrnoException, linkString: string) => void): void;
    statSync(path: string): Stats;
    readdirSync(path: string): string[];
    readFileSync(
        filename: string,
        options:
            | string
            | {
                  encoding: string;
                  flag?: string;
              }
    ): string;
    readFileSync(
        filename: string,
        options?: {
            flag?: string;
        }
    ): Buffer;
    readlinkSync(path: string): string;
}
